import React from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { isSaaSAdmin, isSuperAdmin } from '@/redux/util';

const ClientNavMenu = ({ currentClient }) => {
	const location = useLocation();
	const { pathname } = location;
	const isSaaS = isSaaSAdmin();
	const isSuper = isSuperAdmin();

	const allClientsRoute = pathname === '/clients';

	const toClients =
		!isSaaS && (!currentClient || currentClient.id === 1) && !allClientsRoute ? (
			<span>
				<Link to="/clients">
					<span className="verbose">All </span>Clients
				</Link>
			</span>
		) : null;

	const toAppBranding = !pathname.includes('/clients/') ? (
		<span>
			<Link to={`/clients/${currentClient.id}`}>
				<span className="verbose">App & Domain </span>Branding
			</Link>
		</span>
	) : null;
	const eventsPrefix = allClientsRoute && currentClient ? `${currentClient.name} ` : '';
	const toEvents =
		!pathname.includes('/events') && currentClient ? (
			<span>
				<Link to="/events">{`${eventsPrefix}Events`}</Link>
			</span>
		) : null;
	const toAccounts = !pathname.includes('/accounts') ? (
		<span>
			<Link to="/accounts">
				<span className="verbose">User </span>Accounts
			</Link>
		</span>
	) : null;

	const toAdmins = !pathname.includes('/admins') ? (
		<span>
			<Link to="/admins">Admins</Link>
		</span>
	) : null;

	if (allClientsRoute) {
		return <span className="ClientNavMenu">{toEvents}</span>;
	}

	return (
		<span className="ClientNavMenu">
			{!isSaaS && toClients}
			{toEvents}
			{!isSaaS && toAppBranding}
			{!isSaaS && toAccounts}
			{isSuper && toAdmins}
		</span>
	);
};

const msp = ({ clients }) => ({
	clients: clients.clients,
	currentClient: clients.currentClient,
});

const mdp = () => ({});

export default connect(msp, mdp)(ClientNavMenu);
